@import "../use-bootstrap-mixins.scss";

.bottomPanel {
  position: absolute;
  bottom: 20px;
  height: 80px;
  width: calc(100% - 42px);

  @include media-breakpoint-up(lg) {
    position: relative;
    margin-top: 80px;
    width: 100%;
  }
}

.results_header {
  max-width: 100%;
  position: relative;
}

.title {
  text-align: center;
  margin-top: 28px;
  width: 100%;
  display: block;
}

.labels {
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
  color: #000;
  opacity: 0.7;
  font-size: 12px;
  font-weight: 600;
}

.descriptor_wrapper {
  // min-height: 250px;
  display: flex;
  align-items: center;
  // width: calc(100vw - 42px - 98px); old width calculation, replaced with max-width to stop the carousel from being wack
  max-width: 1000px;
  border-radius: 12px;
  opacity: 0.5;

  @include media-breakpoint-up(lg) {
    min-height: 250px;
  }
}

.mobile {
  display: block;

  @include media-breakpoint-up(lg) {
    display: none !important;
  }
}

.desktop {
  display: none;

  @include media-breakpoint-up(lg) {
    display: block;
    margin-bottom: 35px;
  }
}

.deal_copy {
  padding: 4px 0 10px 0;
  .text {
    display: block;
    font-size: 11px;
    font-weight: 500 !important;
    text-align: right !important;
  }
}
